<template>
    <div class="activity-tooltip">
        <div class="activity-name">
            {{ activityDefinition?.description }}
            <Popper hover arrow placement="right" content="Copy to clipboard" class="cc-tooltip">
                <button class="copy-btn" type="button" @click="copy(activityDefinition?.description, 'name')" aria-label="Copy activity name">
                    <span class="dx-icon-copy"></span>
                </button>
            </Popper>            
            <span v-if="copied === 'name'" class="copied">Copied</span>
        </div>
        <div class="activity-number">
            {{ activityDefinition?.activityNumber }}
            <Popper hover arrow placement="right" content="Copy to clipboard" class="cc-tooltip">
                <button class="copy-btn" type="button" @click="copy(activityDefinition?.activityNumber?.toString() ?? '', 'number')" aria-label="Copy activity number">
                    <span class="dx-icon-copy"></span>
                </button>
            </Popper>
            <span v-if="copied === 'number'" class="copied">Copied</span>
        </div>
    </div>        
</template>

<script lang="ts" setup>
import { DefinitionItem } from '@/services/entities/DefinitionItem';
import { defineProps, ref } from 'vue';  
import Popper from 'vue3-popper';

const props = defineProps<{
  activityDefinition: DefinitionItem | null;
}>();

const copied = ref<string | null>(null);

function copy(text: string | undefined, key: 'name' | 'number') {
  if (!text) return;
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(text).then(() => {
      copied.value = key;
      window.setTimeout(() => (copied.value = null), 1500);
    }).catch(() => fallbackCopy(text, key));
  } else {
    fallbackCopy(text, key);
  }
}

function fallbackCopy(text: string, key: 'name' | 'number') {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.left = '-9999px';
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
    copied.value = key;
    window.setTimeout(() => (copied.value = null), 1500);
  } finally {
    document.body.removeChild(ta);
  }
}
</script>
<style scoped lang="scss">
.activity-tooltip {
  padding: 8px 12px;
  max-width: 340px;
  font-family: inherit;
}

.activity-name {
  font-size: 1rem; /* normal size */
  font-weight: 600;
  line-height: 1.2;
  display: flex;
  align-items: center;
  gap: 8px;
}

.activity-number {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem; /* smaller */
  margin-top: 2px;
}

.copy-btn {
  appearance: none;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 2px 4px;
  font-size: 1rem;
  color: #c3c3c3;
  border-radius: 4px;
}


.copied {
  font-size: 0.75rem;
  color: #2a7f3e;
  font-style: italic;
  margin-left: 6px;
}

.activity-description {
  font-size: 0.75rem; /* smaller */
  font-style: italic;
  margin-top: 6px;
  white-space: normal;
}
.cc-tooltip {
    font-size: 0.85rem;
    font-weight: 990;
}
</style>